export const locales = {
	close: 'Fermer'
};
